import type { FaireProductEntity } from "../../entity_types/product";

export const p_b24h2rg55x: FaireProductEntity = {
  token: "p_b24h2rg55x",
  type: "product",
  name: "Weekly Meal Plan Notepad - Stationery & Market List",
  brandName: "Sweet Water Decor",
  imageUrl:
    "https://cdn.faire.com/fastly/7e430920c018d48af398875cd88a465b4a0ae2324281d342bdf25644414defb9.png",
  priceDollars: 7.5,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/86db89168d4ea94f75c95f3f49342b7232271b5dc15cfe6477ec7a76b0012bad.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
